module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc_head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Sources"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Prologue"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Slavers, Baymen and Buccaneers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Thief from Horseferry")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Parting Glass")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Trouble in Port Roseway")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Across the Atlantic and Back Again")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Marooning of Philip Ashton")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Greyhound")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Hanged by the Neck")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Vanishing Trick")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue")]), _vm._v(": The Treasure of Isle Haute")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Members",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Members of Ned Low’s Crew Captured by HMS")]), _vm._v(" Greyhound")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Platesection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate Section")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0